import { GridColumnType } from '@grid'
import dayjs from 'dayjs'

const dateFormatter = (value: string) =>
	value === null || value === undefined || value === ''
		? ''
		: dayjs(value).format('YYYY-MM-DD')

/**
 * 정산 하단 — 그 달의 판매 행 (`/main/settlement`, DISPATCH_PLAN §6.5).
 * 열 순서는 엑셀 월 시트 뒤 5열을 따른다: 부가세 적립 · 납부 · 후원금 적립 · 납부 · 세금계산서.
 * 금액 · 체크 · 상태 · 채널은 페이지가 `renderCell` 로 그린다(통화별 표기, 체크 즉시 저장).
 * 수정 모드에서 고칠 수 있는 칸: 배송비(우리) · 관세(우리) · 세금계산서 번호 · 메모 — 저장은 `onAction('U')`.
 */
export const settlementColumns: GridColumnType = {
	initRow: {},
	fieldToFocus: 'memo',
	card: {
		title: 'orderId',
		status: 'status',
		subtitle: 'partyName',
		meta: ['orderedAt', 'saleAmount', 'vatReserve', 'donationReserve'],
		sections: [
			{
				title: '금액',
				fields: [
					'orderedAt',
					'channel',
					'itemSummary',
					'saleAmount',
					'materialCost',
					'shippingCost',
					'dutyCost',
				],
			},
			{
				title: '납부',
				fields: ['vatReserve', 'vatPaidYn', 'donationReserve', 'donationPaidYn'],
			},
			{
				title: '세금계산서',
				fields: ['taxInvoiceYn', 'taxInvoiceAt', 'taxInvoiceNo', 'memo'],
			},
		],
	},
	columns: [
		{
			field: 'orderedAt',
			headerName: '주문일',
			headerAlign: 'center',
			align: 'center',
			width: 100,
			editable: false,
			valueFormatter: dateFormatter,
		},
		{
			field: 'orderId',
			headerName: '주문번호',
			headerAlign: 'center',
			width: 190,
			editable: false,
		},
		{
			field: 'channel',
			headerName: '채널',
			headerAlign: 'center',
			align: 'center',
			width: 80,
			editable: false,
		},
		{
			field: 'status',
			headerName: '상태',
			headerAlign: 'center',
			align: 'center',
			width: 90,
			editable: false,
		},
		{
			field: 'partyName',
			headerName: '거래처 / 고객',
			headerAlign: 'center',
			width: 150,
			editable: false,
		},
		{
			field: 'itemSummary',
			headerName: '품목',
			headerAlign: 'center',
			width: 150,
			editable: false,
		},
		{
			field: 'saleAmount',
			headerName: '판매가',
			headerAlign: 'center',
			align: 'right',
			width: 110,
			editable: false,
		},
		{
			field: 'materialCost',
			headerName: '원가',
			headerAlign: 'center',
			align: 'right',
			width: 110,
			editable: false,
		},
		{
			field: 'shippingCost',
			headerName: '배송비(우리)',
			headerAlign: 'center',
			align: 'right',
			width: 110,
			type: 'number',
			editable: true,
		},
		{
			field: 'dutyCost',
			headerName: '관세(우리)',
			headerAlign: 'center',
			align: 'right',
			width: 100,
			type: 'number',
			editable: true,
		},
		{
			field: 'vatReserve',
			headerName: '부가세 적립',
			headerAlign: 'center',
			align: 'right',
			width: 110,
			editable: false,
		},
		{
			field: 'vatPaidYn',
			headerName: '납부',
			headerAlign: 'center',
			align: 'center',
			width: 70,
			editable: false,
			sortable: false,
		},
		{
			field: 'donationReserve',
			headerName: '후원금 적립',
			headerAlign: 'center',
			align: 'right',
			width: 110,
			editable: false,
		},
		{
			field: 'donationPaidYn',
			headerName: '납부',
			headerAlign: 'center',
			align: 'center',
			width: 70,
			editable: false,
			sortable: false,
		},
		{
			field: 'taxInvoiceYn',
			headerName: '세금계산서',
			headerAlign: 'center',
			align: 'center',
			width: 90,
			editable: false,
			sortable: false,
		},
		{
			field: 'taxInvoiceAt',
			headerName: '발행일',
			headerAlign: 'center',
			align: 'center',
			width: 100,
			editable: false,
			valueFormatter: dateFormatter,
		},
		{
			field: 'taxInvoiceNo',
			headerName: '계산서 번호',
			headerAlign: 'center',
			width: 130,
			editable: true,
		},
		{
			field: 'memo',
			headerName: '메모',
			headerAlign: 'center',
			width: 220,
			editable: true,
		},
	],
}
